import React, { useContext } from "react";
import ContactAvatar from "../../cards/ContactAvatar";
import { Button } from "../../ui/button";
import { UserCtx } from "../../../context/userContext";
import { pluralize } from "../../../utils/pluralize";

type Props = {
    contacts: any;
    setStep: any;
};

const SelectedContactsOverlay: React.FC<Props> = ({ contacts, setStep }) => {
    const {user} = useContext(UserCtx)
    
    return (
        <div className="fixed z-[700] bottom-[32px] left-1/2 ml-[-400px] w-[800px] h-[80px] p-[16px] flex items-center justify-between bg-white rounded-[16px] modal-shadow-lg">
            <div className="flex items-center gap-[16px]">
                <p>
                    {pluralize(contacts.length, user?.isCoach ? "client" : "coach", user?.isCoach ? "s" : "es")}{" "}selected
                </p>
                <div className="flex items-center gap-[8px]">
                    {contacts?.map((c: any) => {
                        return (
                            <ContactAvatar
                                key={c.user_id}
                                width={24}
                                height={24}
                                fontSize="text-base"
                                contact={c}
                                bold={false}
                            />
                        );
                    })}
                </div>
            </div>
            <Button
                onClick={() =>
                    setStep((previousStep: number) => previousStep + 1)
                }
                className="text-md"
                size={"lg"}
            >
                Confirm
            </Button>
        </div>
    );
};

export default SelectedContactsOverlay;
